import { computed, inject, Injectable, signal } from '@angular/core';
import { AccVentureDialogData, AccVentureUpdateValues, DropoutUpsertValues } from '@interfaces';
import { AppService, FuncService } from "../../../../services";


@Injectable({
	providedIn: 'root'
})
export class AccVentureDialogDataService {

	private func = inject(FuncService);
	private app = inject(AppService);
	public dialogData = signal<AccVentureDialogData | undefined>(undefined);

	public canEdit = computed(() => this.app.data().permissions.canFacilitateCohorts);

	public async loadData(accVentureId: number) {
		const data = await this.func.accVenture.getDialogData({ accVentureId });
		this.dialogData.set(data);
	}

	// use after removing or updating data to reload
	public async reloadData() {
		const accVentureId = this.dialogData()?.accVentureId;
		if (!accVentureId) return;
		await this.loadData(accVentureId);
	}

	public async updateVentureDetails(values: AccVentureUpdateValues) {
		const accVentureId = this.dialogData()?.accVentureId;
		if (!accVentureId) return;

		await this.func.accVenture.update({ accVentureId, values });
		await this.loadData(accVentureId);
	}

	public async removeEntrepreneur(accEntrepreneurId: number, personId: number, accVentureId: number) {
		await this.func.accVenture.removeEntrepreneur({ accEntrepreneurId, personId, accVentureId });
		await this.reloadData();
	}

	public async addOrUpdateDropout(values: DropoutUpsertValues) {
		const data = this.dialogData();
		if (!data) return;

		const accVentureId = data.accVentureId;
		const dropoutId = data.dropout?.dropoutId;

		if (dropoutId) {
			await this.func.accVenture.updateDropout({ accVentureId, dropoutId, values });
		} else {
			await this.func.accVenture.addDropout({ accVentureId, values });
		}
		await this.reloadData();
	}

}